import React from "react";
import PropTypes from "prop-types";
import { motion } from "framer-motion";
import Typography from "./ui/Typography";
import { cn } from "../utils/classNames";
import { usePrefersReducedMotion } from "../hooks/usePrefersReducedMotion";

const ContentSection = ({ title = "", children, className = "" }) => {
  const prefersReducedMotion = usePrefersReducedMotion();

  return (
    <motion.section
      className={cn("grid gap-4", className)}
      initial={prefersReducedMotion ? false : { y: 16 }}
      whileInView={{ y: 0 }}
      viewport={{ once: true, margin: "-60px" }}
      transition={{ duration: 0.4, ease: [0.25, 1, 0.5, 1] }}
    >
      {title && (
        <Typography
          as="h2"
          variant="h3"
          className="text-foreground sp-heading-rule pb-3 border-b border-dashed border-accent-gold/60"
        >
          {title}
        </Typography>
      )}
      {children}
    </motion.section>
  );
};

ContentSection.propTypes = {
  title: PropTypes.string,
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
};

export default ContentSection;
